module.exports = __webpack_public_path__ + "img/l-cb6-111.4ee6a7f8.gif";